export const TOGGLE_LOCKED = "TOGGLE_LOCKED";
export const TOGGLE_CLOSED = "TOGGLE_CLOSED";
